import { render } from "./DropdownHeading.vue?vue&type=template&id=07c381d4"
import script from "./DropdownHeading.vue?vue&type=script&lang=js"
export * from "./DropdownHeading.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./DropdownHeading.vue?vue&type=style&index=0&id=07c381d4&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script